/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ n: NonNullable<unknown> }} Pm_CandidatesInputs */

const cs_pm_candidates = /** @type {(inputs: Pm_CandidatesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Kandidáti (${i?.n})`)
};

const en_pm_candidates = /** @type {(inputs: Pm_CandidatesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Candidates (${i?.n})`)
};

/**
* | output |
* | --- |
* | "Candidates ({n})" |
*
* @param {Pm_CandidatesInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const pm_candidates = /** @type {((inputs: Pm_CandidatesInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pm_CandidatesInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pm_candidates(inputs)
	return cs_pm_candidates(inputs)
});